const oht = new URL('../../icons/oht.png', import.meta.url).href

export default {
  type: 'OHT',
  description: 'OHT',
  icon: oht,
  group: 'OCS',
  model: {
    type: 'OHT',
    left: 100,
    top: 100,
    width: 20,
    height: 20
  }
}
